import { toast } from '@/components/ui/use-toast';
import { downloadFilefromBuffer } from '@/lib/utils';
import { exportHIORPdf } from '@/services/homeInspectionService';
import { downloadWorkOrderPDF } from '@/services/pe';

export type ExportProcessServiceWorkOrderInput = {
  workOrderId: string;
  workOrderNumber?: string;
  linkedHIWorkOrderID?: string | null;
};

/**
 * PS Export: when a Home Inspection work order is linked, download the HIOR PDF;
 * otherwise keep the standard Work Order PDF export.
 * Does not fall back to Work Order PDF when a linked ID is present but HIOR fails.
 */
export const exportProcessServiceWorkOrder = async (
  input: ExportProcessServiceWorkOrderInput
): Promise<{ ok: boolean }> => {
  const trimmedLinkedId = input.linkedHIWorkOrderID?.trim();
  const linkedId = trimmedLinkedId && trimmedLinkedId.length > 0 ? trimmedLinkedId : null;

  if (linkedId) {
    toast({
      description: 'Download will start shortly',
      duration: 3000,
    });

    const { data, error } = await exportHIORPdf(linkedId);
    if (error != null || data == null) {
      toast({
        description: 'FAILED TO EXPORT HIOR PDF',
        variant: 'destructive',
        duration: 5000,
      });
      return { ok: false };
    }

    downloadFilefromBuffer(data, `${input.workOrderNumber ?? linkedId}.pdf`, 'PDF');
    return { ok: true };
  }

  const ok = await downloadWorkOrderPDF(input.workOrderId, input.workOrderNumber);
  return { ok };
};
